export const HISTORY_DRAWER_TITLES = {
    OWNER_HISTORY: 'Owner History',
    CUSTOM_FIELD_HISTORY: 'Field History',
} as const;

export const HISTORY_DRAWER_DISPLAY = {
    SYSTEM_USER_FALLBACK: 'System',
    EMPTY_VALUE_DISPLAY: 'None',
} as const;

export const HISTORY_DRAWER_API_PATHS = {
    GET_HISTORY: 'account/getHistory',
    // Underwriting audit history (GF-6) — UW's generic /audit/getHistory behind the polus
    // BEFE, a separate audit store from `account/getHistory`'s fl-aicaDb.AuditLog. Used by
    // the Management Profile drawer today; named generically because the backend is.
    UW_AUDIT_HISTORY: '/unifier/uwAuditHistory',
} as const;
